import React, { useState } from 'react';
import { useRoom } from '../context/RoomContext';
import { useAuth } from '../context/AuthContext';
import './SettingsModal.css';

const SettingsModal = ({ onClose, currentBgColor, onBgColorChange }) => {
  const { room, socketId } = useRoom();
  const { user } = useAuth();
  
  // Check if current user is the host
  const isHost = user && room && (room.hostId === socketId);
  
  // Available background colors
  const backgroundColors = [
    { name: 'Bleu nuit', value: '#1a1a2e' },
    { name: 'Indigo sombre', value: '#1e1b4b' },
    { name: 'Violet profond', value: '#2e1a4b' },
    { name: 'Prune', value: '#3b1a4b' },
    { name: 'Gris anthracite', value: '#2d3748' },
    { name: 'Vert forêt', value: '#1a2e1a' },
  ];
  
  // Local settings state
  const [settings, setSettings] = useState({
    allowParticipantsShareScreen: false,
    allowParticipantsChat: true,
    allowParticipantsUnmute: true,
    allowParticipantsVideo: true,
  });

  const handleSettingChange = (setting) => {
    setSettings(prev => ({
      ...prev,
      [setting]: !prev[setting]
    }));
  };

  const handleSave = () => {
    // TODO: Save settings to backend
    console.log('Saving settings:', settings);
    onClose();
  };

  return (
    <div className="settings-modal-overlay" onClick={onClose}>
      <div className="settings-modal" onClick={e => e.stopPropagation()}>
        <div className="settings-modal-header">
          <h2>Paramètres de la réunion</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        
        <div className="settings-modal-content">
          {isHost ? (
            <>
              <div className="settings-section">
                <h3>Permissions des participants</h3>
                
                <div className="settings-setting-item">
                  <label className="setting-label">
                    <input
                      type="checkbox"
                      checked={settings.allowParticipantsShareScreen}
                      onChange={() => handleSettingChange('allowParticipantsShareScreen')}
                    />
                    <span className="setting-text">Autoriser les participants à partager leur écran</span>
                  </label>
                  <p className="setting-description">
                    Si désactivé, seuls les hôtes peuvent partager leur écran. Les participants doivent demander la permission.
                  </p>
                </div>

                <div className="settings-setting-item">
                  <label className="setting-label">
                    <input
                      type="checkbox"
                      checked={settings.allowParticipantsChat}
                      onChange={() => handleSettingChange('allowParticipantsChat')}
                    />
                    <span className="setting-text">Autoriser les participants à utiliser le chat</span>
                  </label>
                </div>

                <div className="settings-setting-item">
                  <label className="setting-label">
                    <input
                      type="checkbox"
                      checked={settings.allowParticipantsUnmute}
                      onChange={() => handleSettingChange('allowParticipantsUnmute')}
                    />
                    <span className="setting-text">Autoriser les participants à se désactiver le micro</span>
                  </label>
                </div>

                <div className="settings-setting-item">
                  <label className="setting-label">
                    <input
                      type="checkbox"
                      checked={settings.allowParticipantsVideo}
                      onChange={() => handleSettingChange('allowParticipantsVideo')}
                    />
                    <span className="setting-text">Autoriser les participants à activer leur vidéo</span>
                  </label>
                </div>
              </div>
            </>
          ) : (
            <div className="settings-section">
              <p className="settings-info">
                Seul l'hôte peut modifier les paramètres de la réunion.
              </p>
            </div>
          )}

          <div className="settings-section">
            <h3>Apparence de l'interface</h3>
            
            <div className="settings-setting-item" style={{ flexDirection: 'column', alignItems: 'flex-start', gap: '12px' }}>
              <span className="setting-text">Couleur de fond</span>
              <div className="color-picker-grid">
                {backgroundColors.map((color) => (
                  <button
                    key={color.value}
                    className={`color-option ${currentBgColor === color.value ? 'selected' : ''}`}
                    style={{ backgroundColor: color.value }}
                    onClick={() => onBgColorChange(color.value)}
                    title={color.name}
                  />
                ))}
              </div>
            </div>
          </div>

          <div className="settings-section">
            <h3>Informations sur la réunion</h3>
            <div className="meeting-info">
              <p><strong>Nom:</strong> {room?.name || 'N/A'}</p>
              <p><strong>ID:</strong> {room?.id || 'N/A'}</p>
              <p><strong>Participants:</strong> {room?.participants?.length || 0}</p>
              <p><strong>Hôte:</strong> {isHost ? 'Vous' : 'Autre participant'}</p>
            </div>
          </div>
        </div>

        <div className="settings-modal-footer">
          <button className="btn-secondary" onClick={onClose}>
            Annuler
          </button>
          {isHost && (
            <button className="btn-primary" onClick={handleSave}>
              Enregistrer
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default SettingsModal;